import { Decimal } from "@formatjs/bigdecimal";
export const ZERO = new Decimal(0);
export const NEGATIVE_ZERO = new Decimal(-0);
